import styled from 'styled-components'
import { UpArrowAlt } from '@styled-icons/boxicons-regular/UpArrowAlt'
import { DownArrowAlt } from '@styled-icons/boxicons-regular/DownArrowAlt'

export const RAWrapper = styled.div`
  margin-top: 30px;
  padding: 30px 20px;
  border: 2px solid #78909c;
  box-shadow: #26323840 0px 4px 12px 0px;
  border-radius: 10px;
  background-color: #FFFFFF;
`

export const UpArrow = styled(UpArrowAlt)`
  width: 40px;
  color: red;
`

export const DownArrow = styled(DownArrowAlt)`
  width: 40px;
  color: green;
`

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
`

export const SubTitle = styled.h2``

export const Divider = styled.div`
  background-color: #78909c;
  width: 70%;
  height: 2px;
  margin: 20px auto 20px auto;
`
